import React, { useState } from 'react';
import { DropOffLocationCardProps } from '../Interfaces/DropOff';
import getCheckOut from '../hooks/getCheckOut';

const DropOffLocationCard: React.FC<DropOffLocationCardProps> = ({
  title,
  mapUrl,
  website,
  address,
  locationNote,
  hours,
  linkText,
  linkHref,
}) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);

  const handleSignUp = async () => {
    if (!showEmailInput) {
      setShowEmailInput(true);
      return;
    }

    const emailRegex = /[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,3}$/;
    if (!email || !emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await getCheckOut("dropoff", email, title);
      const data = await response.json();
      console.log(data);
      window.location.href = data.url; // Adjust based on your API response structure
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full">
      <div className="relative h-64">
        <iframe
          title={`${title} Location Map`}
          src={mapUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0"
        />
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-2xl font-bold text-[#b05e2c] mb-2">
          <a
            href={website}
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-orange-700 transition-colors"
          >
            {title}
          </a>
        </h3>
        <p className="text-gray-700 mb-2">
          <strong>Address:</strong> {address}
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Location:</strong> {locationNote}
        </p>
        <p className="text-gray-700 mb-4">
          <strong>Hours:</strong> {hours}
        </p>
        
        {showEmailInput && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address *
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,3}$"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="your@email.com"
            />
          </div>
        )}
        
        <button
          onClick={handleSignUp}
          disabled={isLoading}
          className="mt-auto bg-[#b05e2c] text-white px-6 py-3 rounded hover:bg-orange-700 transition-colors disabled:opacity-50"
        >
          {isLoading ? "Processing..." : showEmailInput ? "Sign Up - $15/month" : linkText}
        </button>
      </div>
    </div>
  )
};

export default DropOffLocationCard;
